import React from "react";
import { Link } from "react-router-dom";
import Container from "./Container";
import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";
import PunchCardLogo from "./logos/PunchCardLogo";
import AnimatedBackground from "./AnimatedBackground";

interface FooterProps {
  className?: string;
}

const Footer: React.FunctionComponent<FooterProps> = ({ className }) => {
  return (
    
    <AnimatedBackground 
    fullHeight={false}
    className="bg-neutral-1000"
  >
    <footer className={cn("dark relative text-foreground pt-80 pb-24", className)}>
        <Container>
          <div className="flex flex-col gap-12">
            {/* Logo - Full Width */}
            <PunchCardLogo size="lg" iconClassName="text-highlight-500" />
            
            {/* Bottom Row - Company Name and Links */}
            <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between md:gap-8">
              <Text as="span" className="text-foreground font-medium whitespace-nowrap shrink-0">
                Punch Cards, Ltd.
              </Text>

              {/* Right side - Links and Button */}
              <nav className="flex flex-col items-start gap-3 md:flex-row md:items-center md:gap-6 md:shrink-0">
                <Link
                  to="/sign-in"
                  className="text-foreground/80 hover:text-foreground transition-colors whitespace-nowrap"
                >
                  Sign in
                </Link>
                <Link
                  to="/waitlist"
                  className="text-foreground/80 hover:text-foreground transition-colors whitespace-nowrap"
                >
                  Join the waitlist
                </Link>
                <Link
                  to="/free"
                  className="text-foreground/80 hover:text-foreground transition-colors whitespace-nowrap"
                >
                  Free resource
                </Link>
<Link
                  to="/privacy"
                  className="text-foreground/80 hover:text-foreground transition-colors whitespace-nowrap"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  className="text-foreground/80 hover:text-foreground transition-colors whitespace-nowrap"
                >
                  Terms of Service
                </Link>
                {/* <Button asChild variant="default" size="default">
                  <Link to="/sign-up">Sign up</Link>
                </Button> */}
              </nav>
            </div>
          </div>
        </Container>
    </footer>
    </AnimatedBackground>
  );
};

export default Footer;
